// require('lazyload');

jQuery("document").ready(function ($) {
  $(".post-content p").each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, "").length == 0) $this.remove();
  });

  var url = $("#video-iframe").attr("src");
  var $videoModal = $("#video-modal");

  $videoModal.on("hide.bs.modal", function () {
    $("#video-iframe").attr("src", "");
  });

  $videoModal.on("hidden.bs.modal", function () {
    if ($videoModal.attr("src") !== url) {
      console.log("inn", $videoModal.attr("src"));
      console.log("url", url);
      $("#video-iframe").attr("src", url);
    }
  });

  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on("load resize scroll", function () {
    var $elementsWhenInViewport = $(".d-when-in-viewport");
    $elementsWhenInViewport.each(function (index) {
      if ($(this).isInViewport()) {
        $(this).show().removeClass("d-when-in-viewport");
      }
    });
  });

  // BEGIN: Top nav search field
  $searchField = $(".js_searchField");
  $searchIcon = $(".js_searchIcon");

  $searchIcon.click(function () {
    if (!$searchField.val()) {
      $searchField.focus();
    } else {
      $searchField.closest("form").submit();
    }
  });

  $searchField.focus(function () {
    $(".search-box--slide").addClass("hover");
  });
  $searchField.focusout(function () {
    $(".search-box--slide").removeClass("hover");
  });
  // END: Top nav search field

  var $showMember = $(".js_showMember");
  if ($showMember.length > 0) {
    var memberId = $showMember.data("member-id");
  }

  $(function () {
    $('[data-toggle="tooltip"]').tooltip({ container: "body" });
  });

  // BEGIN: SOCIAL SHARE ICON LINK GENERATOR

  function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params =
      "menubar=no,toolbar=no,status=no,width=570,height=570,top=" +
      top +
      ",left=" +
      left;
    window.open(url, "NewWindow", params);
  }

  function setShareLinks() {
    var siteName = encodeURIComponent(
      $("meta[property='og:site_name']").attr("content")
    );
    var pageTitle = encodeURIComponent(
      document.getElementsByTagName("title")[0].innerHTML
    );
    var pageUrl = encodeURIComponent(document.URL);
    var tweet = encodeURIComponent(
      $("meta[property='og:description']").attr("content")
    );

    $(".social-share.facebook").on("click", function () {
      url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
      socialWindow(url);
    });

    $(".social-share.twitter").on("click", function () {
      url =
        "https://twitter.com/intent/tweet?url=" +
        pageUrl +
        "&text=" +
        pageTitle;
      socialWindow(url);
    });

    $(".social-share.linkedin").on("click", function () {
      url =
        "https://www.linkedin.com/shareArticle?mini=true&url=" +
        pageUrl +
        "&title=" +
        pageTitle +
        "&summary=" +
        tweet +
        "&source=" +
        siteName;
      socialWindow(url);
    });

    $(".social-share.email").on("click", function () {
      url =
        encodeURI("mailto:?subject=I want to share this article with you: ") +
        pageTitle +
        "&body=" +
        pageUrl;
      socialWindow(url);
    });
  }

  // only load "setShareLinks()" when social-share elements are on page
  if ($(".social-share").length) {
    setShareLinks();
  }
  // END: SOCIAL SHARE ICON LINK GENERATOR

  $topNavCollapsible = $(".topNavCollapsible");
  $topNavCollapsibleNavLinks = $(
    ".topNavCollapsible .nav-link, .topNavCollapsible .dropdown-item"
  ).not(".dropdown-toggle");
  $topNavCollapsibleNavLinks.on("click", function () {
    $topNavCollapsible.collapse("hide");
  });
});
